import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":3361/market/product";
};

export const mallLoadProductList = (shopID, params) => {
  const url = `${baseURL()}/load/${shopID}`;

  return axios.post(url, params);
};

export const mallGetProductDetail = (shopID, productID) => {
  const url = `${baseURL()}/load/${shopID}/${productID}`;

  return axios.get(url);
};
